export default __webpack_public_path__ + "static/media/Peppe Volyarelli.db781827.jpg";